import { ProductCategory } from "@utils/constants";

const diamondSortingFilters = (t: any) => {
  return [
    {
      name: "Status",
      label: t("searchResult.listViewTablet.header.status"),
      priceModes: [1],
    },
    {
      name: "discount_percent",
      label: t("sortingScreen.filterOptions.discount.text"),
      priceModes: [1],
    },
    {
      name: "price_per_carat",
      label: t("sortingScreen.filterOptions.pricePerCarat.text"),
      priceModes: [1, 2],
    },
    {
      name: "total_price",
      label: t("sortingScreen.filterOptions.totalPrice.text"),
      priceModes: [1, 2],
    },
    {
      name: "size",
      label: t("sortingScreen.filterOptions.caratWeight.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "shape",
      label: t("sortingScreen.filterOptions.shape.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "color",
      label: t("sortingScreen.filterOptions.color.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "clarity",
      label: t("sortingScreen.filterOptions.clarity.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "cut",
      label: t("sortingScreen.filterOptions.cut.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "polish",
      label: t("sortingScreen.filterOptions.polish.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "symmetry",
      label: t("sortingScreen.filterOptions.symmetry.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "meas_length",
      label: t("sortingScreen.filterOptions.measurements.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "meas_ratio",
      label: t("sortingScreen.filterOptions.ratio.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "fluor_intensity",
      label: t("sortingScreen.filterOptions.fluorescence.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "depth_percent",
      label: t("sortingScreen.filterOptions.depth.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "table_percent",
      label: t("sortingScreen.filterOptions.table.text"),
      priceModes: [0, 1, 2],
    },
  ];
};

const gemstoneSortingFilters = (t: any) => {
  return [
    {
      name: "Status",
      label: t("searchResult.listViewTablet.header.status"),
      priceModes: [1],
    },
    {
      name: "price_per_carat",
      label: t("sortingScreen.filterOptions.pricePerCarat.text"),
      priceModes: [1, 2],
    },
    {
      name: "total_price",
      label: t("sortingScreen.filterOptions.totalPrice.text"),
      priceModes: [1, 2],
    },
    {
      name: "size",
      label: t("sortingScreen.filterOptions.caratWeight.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "shape",
      label: t("sortingScreen.filterOptions.shape.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "color",
      label: t("sortingScreen.filterOptions.color.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "gem_type",
      label: t("sortingScreen.filterOptions.gemType.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "meas_length",
      label: t("sortingScreen.filterOptions.measurements.text"),
      priceModes: [0, 1, 2],
    },
  ];
};

const jewelrySortingFilters = (t: any) => {
  return [
    {
      name: "Status",
      label: t("searchResult.listViewTablet.header.status"),
      priceModes: [1],
    },
    {
      name: "total_price",
      label: t("sortingScreen.filterOptions.jewelry.price.text"),
      priceModes: [1, 2],
    },
    {
      name: "center_size",
      label: t("sortingScreen.filterOptions.jewelry.centerStoneWeight.text"),
      priceModes: [0, 1, 2],
    },
  ];
};

const labgrownSortingFilters = (t: any) => {
  return [
    {
      name: "Status",
      label: t("searchResult.listViewTablet.header.status"),
      priceModes: [1],
    },
    {
      name: "discount_percent",
      label: t("sortingScreen.filterOptions.discount.text"),
      priceModes: [1],
    },
    {
      name: "price_per_carat",
      label: t("sortingScreen.filterOptions.pricePerCarat.text"),
      priceModes: [1, 2],
    },
    {
      name: "total_price",
      label: t("sortingScreen.filterOptions.totalPrice.text"),
      priceModes: [1, 2],
    },
    {
      name: "size",
      label: t("sortingScreen.filterOptions.caratWeight.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "shape",
      label: t("sortingScreen.filterOptions.shape.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "color",
      label: t("sortingScreen.filterOptions.color.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "clarity",
      label: t("sortingScreen.filterOptions.clarity.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "cut",
      label: t("sortingScreen.filterOptions.cut.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "polish",
      label: t("sortingScreen.filterOptions.polish.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "symmetry",
      label: t("sortingScreen.filterOptions.symmetry.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "meas_length",
      label: t("sortingScreen.filterOptions.measurements.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "meas_ratio",
      label: t("sortingScreen.filterOptions.ratio.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "fluor_intensity",
      label: t("sortingScreen.filterOptions.fluorescence.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "depth_percent",
      label: t("sortingScreen.filterOptions.depth.text"),
      priceModes: [0, 1, 2],
    },
    {
      name: "table_percent",
      label: t("sortingScreen.filterOptions.table.text"),
      priceModes: [0, 1, 2],
    },
  ];
};

const getSortingFiltersOptions = (
  t: any,
  priceMode: number,
  productType: string
) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return diamondSortingFilters(t).filter((option) =>
        option.priceModes.includes(priceMode)
      );
    case ProductCategory.GEMSTONE:
      return gemstoneSortingFilters(t).filter((option) =>
        option.priceModes.includes(priceMode)
      );
    case ProductCategory.JEWELRY:
      return jewelrySortingFilters(t).filter((option) =>
        option.priceModes.includes(priceMode)
      );
    default:
      return labgrownSortingFilters(t).filter((option) =>
        option.priceModes.includes(priceMode)
      );
  }
};

export { getSortingFiltersOptions };
